<pay-club-applet-ui-dialog-btm-sheet
  [title]="'اعتباری پرداخت کن تا بیشتر امتیاز بگیری'"
  [closeable]="true"
  [titleRight]="true"
>
  <div
    class="content"
    body
  >
    شما می‌توانید در طول ماه با استفاده از پرداخت اعتباری دیجی‌پی، تراکنش‌هایی مثل پرداخت قبض، خرید شارژ  و بسته اینترنت رو انجام بدید و به
    ازای هر تراکنش اعتباری ۵ سکه بیشتر دریافت کنید.
    <div class="note-wrapper">
      <div class="title">نحوه دریافت امتیاز</div>
      <div class="note-explanation">
        در زمان پرداخت هزینه‌ی مربوط به تراکنش، <strong>(روش پرداخت اعتباری)</strong> را انتخاب و پرداخت خود را نهایی کنید.
      </div>
    </div>
  </div>
</pay-club-applet-ui-dialog-btm-sheet>
